import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCartIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

// Cart icon component with badge
export const CartIcon = ({ cartCount, className = "h-5 w-5" }) => (
  <div className="relative">
    <ShoppingCartIcon className={className} />
    {cartCount > 0 && (
      <span className="absolute -top-3 -right-3 bg-brand-orange text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
        {cartCount}
      </span>
    )}
  </div>
);

// Message icon component with unread badge
export const MessageIcon = ({ unreadCount, className = "h-5 w-5" }) => (
  <div className="relative">
    <ChatBubbleLeftRightIcon className={className} />
    {unreadCount > 0 && (
      <span className="absolute -top-3 -right-3 bg-brand-orange text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
        {unreadCount}
      </span>
    )}
  </div>
);

const ActionItems = ({ items, activeItem, isMobile = false }) => {
  return (
    <>
      {items.map((item) =>
        item.onClick ? (
          <button
            key={item.name}
            onClick={item.onClick}
            className={`
              ${isMobile
                ? 'flex items-center w-full px-4 py-2 text-sm text-gray-600 hover:text-brand-teal hover:bg-gray-50 rounded-md'
                : 'p-2 rounded-full text-gray-500 hover:text-brand-teal hover:bg-gray-100 transition-colors duration-200'
              }
            `}
            aria-label={item.name}
          >
            {item.icon ? (
              <span className={isMobile ? 'mr-3' : ''}>{item.icon}</span>
            ) : null}
            {(!item.icon || isMobile) && <span className={!item.icon && !isMobile ? 'text-sm font-medium' : ''}>{item.name}</span>}
          </button>
        ) : item.isExternal ? (
          <a
            key={item.name}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`
              ${isMobile
                ? 'flex items-center w-full px-4 py-2 text-sm text-gray-600 hover:text-brand-teal hover:bg-gray-50 rounded-md'
                : 'p-2 rounded-full text-gray-500 hover:text-brand-teal hover:bg-gray-100 transition-colors duration-200'
              }
              ${activeItem === item.name ? 'text-brand-teal' : ''}
            `}
            aria-label={item.name}
          >
            {item.icon ? (
              <span className={isMobile ? 'mr-3' : ''}>{item.icon}</span>
            ) : null}
            {(!item.icon || isMobile) && <span className={!item.icon && !isMobile ? 'text-sm font-medium' : ''}>{item.name}</span>}
          </a>
        ) : (
          <Link
            key={item.name}
            to={item.link}
            className={`
              ${isMobile
                ? 'flex items-center w-full px-4 py-2 text-sm text-gray-600 hover:text-brand-teal hover:bg-gray-50 rounded-md'
                : 'p-2 rounded-full text-gray-500 hover:text-brand-teal hover:bg-gray-100 transition-colors duration-200'
              }
              ${activeItem === item.name ? 'text-brand-teal' : ''}
            `}
            aria-label={item.name}
          >
            {item.icon ? (
              <span className={isMobile ? 'mr-3' : ''}>{item.icon}</span>
            ) : null}
            {(!item.icon || isMobile) && <span className={!item.icon && !isMobile ? 'text-sm font-medium' : ''}>{item.name}</span>}
          </Link>
        )
      )}
    </>
  );
};

export default ActionItems;